const Collection = {
  init: function () {
    if (!document.querySelector(".template-collection")) return

    this.initAccordion()
  },

  initAccordion: function () {
    if (!document.querySelector(".collectionAccordion")) return

    const accordionToggle = document.querySelector(
      ".collectionAccordion__toggle"
    )
    const accordionList = document.querySelector(".collectionAccordion__list")

    accordionToggle.addEventListener("click", () => {
      if (accordionToggle.classList.contains("closed")) {
        accordionList.style.maxHeight = `${accordionList.scrollHeight}px`
        setTimeout(() => {
          accordionList.style.maxHeight = "none"
        }, 210)
      } else {
        accordionList.style.maxHeight = `${accordionList.scrollHeight}px`
        setTimeout(() => {
          accordionList.style.maxHeight = "0px"
        }, 10)
      }

      accordionToggle.classList.toggle("closed")
    })

    document
      .querySelectorAll(".collectionAccordion__itemQuestion")
      .forEach((el) => {
        el.addEventListener("click", () => {
          el.parentNode.classList.toggle("open")
        })
      })

    window.addEventListener("resize", () => {
      if (!accordionToggle.classList.contains("closed")) {
        accordionList.style.maxHeight = `${accordionList.scrollHeight}px`
      }
    })
  },
}

export default Collection
